import {
  createDirectFedexCarrierAccountInputSchema,
  createDirectFedexCarrierAccountOutputSchema,
} from "@redotech/redo-model/fulfillments/fedex-customer-registration";

export const createDirectFedexCarrierAccount = {
  name: "createDirectFedexCarrierAccount" as const,
  input: createDirectFedexCarrierAccountInputSchema,
  output: createDirectFedexCarrierAccountOutputSchema,
};
